import { render, staticRenderFns } from "./FormSpinbutton.vue?vue&type=template&id=770ea035"
import script from "./FormSpinbutton.vue?vue&type=script&lang=js"
export * from "./FormSpinbutton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports